module.exports = __webpack_public_path__ + "img/logo.eb1e15be.png";